import { graphql } from 'gatsby';
import React from 'react';
import { getSettingsClass } from '~/utils/helpers';

type StreamPriceItem = {
  title: string;
  subtitle: string;
  comparison_items: {
    small: string;
    normal: string;
  }[];
  text: string;
};

interface StreamPriceComparisonProps {
  block: {
    settings?: Settings;
    theme?: 'relaxed' | 'compact';
    css_class_name?: string;
    stream_price_left: StreamPriceItem;
    stream_price_right: StreamPriceItem;
  };
}

const StreamPriceSide: React.FC<{
  item: StreamPriceItem;
  side: 'left' | 'right';
}> = ({ item, side }) => {
  return (
    <div className={`content-wr ${side}`}>
      {item.title && (
        <h3
          className='col-title'
          dangerouslySetInnerHTML={{
            __html: item.title,
          }}
        />
      )}
      {item.subtitle && (
        <div
          className='small px-12'
          dangerouslySetInnerHTML={{
            __html: item.subtitle,
          }}
        />
      )}
      <div className='content'>
        <div className='comparison'>
          {item.comparison_items.map((comparison, index) => (
            <div
              key={index}
              className='item'
            >
              <div
                className='small'
                dangerouslySetInnerHTML={{ __html: comparison.small }}
              />
              <div
                className='normal'
                dangerouslySetInnerHTML={{ __html: comparison.normal }}
              />
            </div>
          ))}
        </div>
        {item.text && (
          <div
            className='text-formatted'
            dangerouslySetInnerHTML={{ __html: item.text }}
          ></div>
        )}
      </div>
    </div>
  );
};

const StreamPriceComparison: React.FC<StreamPriceComparisonProps> = ({
  block,
}) => {
  const settingsClass = getSettingsClass(block.settings);
  const themeClass = `stream_price_comparison--${block.theme ? block.theme : 'relaxed'}`;
  const colsClass = `col-12 col-lg-6 ${block.theme === 'compact' ? 'col-xl-5' : 'col-xl-6'}`;
  const className = block.css_class_name ? block.css_class_name : '';
  const { stream_price_left, stream_price_right } = block;
  return (
    <section
      className={`block__stream_price_comparison block ${themeClass} ${settingsClass} ${className}`}
    >
      <div className='container'>
        <div className='row'>
          <div className={colsClass}>
            {stream_price_left?.comparison_items && (
              <StreamPriceSide
                item={stream_price_left}
                side='left'
              />
            )}
          </div>
          <div className={colsClass}>
            {stream_price_right.comparison_items && (
              <StreamPriceSide
                item={stream_price_right}
                side='right'
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StreamPriceComparison;

export const StreamPriceItemFragment = graphql`
  fragment StreamPriceItemFragment on StreamPriceItem {
    title
    subtitle
    comparison_items {
      small
      normal
    }
    text
  }
`;

export const streamPriceComparisonFragment = graphql`
  fragment StreamPriceComparisonFragment on Block {
    _template
    settings {
      ...SettingsFragment
    }
    theme
    stream_price_left {
      ...StreamPriceItemFragment
    }
    stream_price_right {
      ...StreamPriceItemFragment
    }
  }
`;
